import { useEffect, useState } from 'react';
import { getDepartments, getExamTypes, getServices, getExamSpecialties, getCompanies } from '../../../services/general';
import debounce from 'lodash/debounce';
import { message } from 'antd';
import { useTranslation } from "react-i18next";
import { PRESTATIONS_SEARCH_DEBOUNCE_MS, hasEnoughSearchLength } from '../../../utils/searchConfig';

const useGeneralInfo = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState({
    department: false,
    services: false,
    serviceType: false,
    serviceSpecialty: false,
  });
  const [departments, setDeparments] = useState([]);
  const [services, setServices] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);
  const [serviceSpecialties, setSpecialties] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [error, setError] = useState(null);

  const fetchDepartments = () => {
    setLoading(loading => { return { ...loading, department: true } });
    getDepartments()
      .then(response => setDeparments(response))
      .catch(error => setError(error))
      .finally(() => setLoading(loading => { return { ...loading, department: false } }));
  };

  const fetchServices = debounce((name) => {
    setLoading(loading => { return { ...loading, services: true } });
    if (hasEnoughSearchLength(name)) {
      getServices({ query: name, limit: 50 })
        .then(response => setServices(response))
        .catch(error => setError(error))
        .finally(() => setLoading(loading => { return { ...loading, services: false } }));
    } else {
      setServices([]);
      setLoading(loading => { return { ...loading, services: false } });
    }
  }, PRESTATIONS_SEARCH_DEBOUNCE_MS);

  const fetchServiceTypes = () => {
    setLoading(loading => { return { ...loading, serviceType: true } });
    getExamTypes()
      .then(response => setServiceTypes(response))
      .catch(error => setError(error))
      .finally(() => setLoading(loading => { return { ...loading, serviceType: false } }));
  };

  const fetchSpecialties = async () => {
    setLoading(loading => ({ ...loading, serviceSpecialty: true }));
    try {
      const response = await getExamSpecialties();
      setSpecialties(response);
    } catch (error) {
      setError(error)
    } finally {
      setLoading(loading => ({ ...loading, serviceSpecialty: false }))
    }
  };

  const fetchCompanies = debounce(async (name) => {
      try {
        const response = await getCompanies({ query: name, limit: 30 });
        setCompanies(response?.data || response || []);
      } catch (error) {
        setError(error);
        message.error({
          content: `Error al buscar ${t('exams.companies')}.`,
          style: {
            marginTop: '40vh',
          },
        });
      }
  }, 500);

  useEffect(() => {
    fetchDepartments();
    fetchServiceTypes();
    fetchSpecialties();
  }, []);

  useEffect(() => {
    if (error) {
      message.error({
        content: `Error: ${error}`,
        style: {
          marginTop: '40vh',
        },
      })
    }
  }, [error]);

  return {
    loading,
    departments,
    services,
    serviceTypes,
    serviceSpecialties,
    companies,
    fetchServices,
    fetchCompanies,
    setServices,
    setCompanies,
  };
};

export default useGeneralInfo;